import { readPersistedSessionIds } from './sessionIds';
import { emptyUserPrefsV1, mergeUserPrefsPatch, readUserPrefsDoc } from './userPrefs';

/**
 * @param {unknown} o
 * @returns {o is Array<{ id: string, desc: boolean }>}
 */
function isSortState (o) {
    if (!Array.isArray(o))
        return false;
    if (o.length === 0)
        return true;
    return o.every(
        s =>
            s &&
            typeof s === 'object' &&
            typeof s.id === 'string' &&
            s.id.length > 0 &&
            typeof s.desc === 'boolean'
    );
}

/**
 * @returns {Record<string, Array<{ id: string, desc: boolean }>>}
 */
export function readPersistedListTablesSortStateMap () {
    if (typeof window === 'undefined' || !window.localStorage) {
        return {};
    }
    try {
        const { userId } = readPersistedSessionIds();
        if (!userId) {
            return {};
        }
        const doc   = readUserPrefsDoc(userId);
        const raw   = doc?.listTablesSortState;
        if (!raw || typeof raw !== 'object') {
            return {};
        }
        /** @type {Record<string, unknown>} */
        const out = {};
        for (const [tableId, v] of Object.entries(raw)) {
            if (isSortState(v)) {
                out[tableId] = v;
            }
        }
        return out;
    } catch {
        return {};
    }
}

/**
 * Merge one table’s sort into `kronos.user.<id>.listTablesSortState`.
 * @param {string|null|undefined} userId
 * @param {string} tableId
 * @param {Array<{ id: string, desc: boolean }>|null|undefined} sortState
 */
export function persistTableSortStateToUserPrefs (userId, tableId, sortState) {
    if (!userId) {
        return;
    }
    if (!tableId) {
        return;
    }
    const arr = Array.isArray(sortState) && isSortState(sortState) ? sortState : [];
    const cur   = readUserPrefsDoc(userId) || emptyUserPrefsV1();
    const prev  = (cur.listTablesSortState && typeof cur.listTablesSortState === 'object')
        ? cur.listTablesSortState
        : {};
    mergeUserPrefsPatch(userId, {
        listTablesSortState: {
            ...prev,
            [tableId]: arr,
        },
    });
}
